import './styles/app.scss';
import { AnimatePresence } from 'framer-motion';
import axios from 'axios';
import VoteCard from './components/VoteCard';
import Modal from './components/Modal';
import Thanks from './components/Thanks';
import Results from './components/Results';
import { useState, useEffect } from 'react';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-199221440-5');

function App() {
  const [dataObj, changeObj] = useState({
      makai: "",
      zhp: ""
  })

  const [hasVoted, changeVoted] = useState(false)
  const vote = () => {
      if(!hasVoted){
        axios.post("https://mds.nisamerica.com/contest-api/vol-2-reverse-cover",{
          dataObj: dataObj,
          img: ""
        })
        .then ((response)=>{
          console.log(response)
        }, (error) => {
          console.log(error)
        })
      changeVoted(true)
    }
  }

  const [viewThanks, changeThanks] = useState(false)
  const openThanks = () => {changeThanks(true)}
  const closeThanks = () => {changeThanks(false)}

  const [results, showResults] = useState(false)
  const openResults = () => {showResults(true)}
  const closeResults = () => {showResults(false)}

  const handleChange = (name, value) => {
    const newData = {...dataObj};
    newData.[name] = value;
    changeObj(newData)
  }

  const [preorder, showPreorder] = useState(false)
  const [trailer, showTrailer] = useState(false)

  const [makaiOne, updateMO] = useState()
  const [makaiTwo, updateMT] = useState()
  const [makaiThree, updateMTH] = useState()

  const [zhpOne, updateZO] = useState()
  const [zhpTwo, updateZT] = useState()
  const [zhpThree, updateZTH] = useState()

  const [voteTotal, updateTotal] = useState()

  useEffect(()=> {
    const axiosPosts = async () => {
      try {
        const response = await axios.get("https://mds.nisamerica.com/contest-api/safe/vol-2-reverse-cover")
        if(response && response.data) {
          console.log(response.data)
          updateMO(response.data.normal.filter(element=>(element.makai === "1")).length)
          updateMT(response.data.normal.filter(element=>(element.makai === "2")).length)
          updateMTH(response.data.normal.filter(element=>(element.makai === "3")).length)
          updateZO(response.data.normal.filter(element=>(element.zhp === "1")).length)
          updateZT(response.data.normal.filter(element=>(element.zhp === "2")).length)
          updateZTH(response.data.normal.filter(element=>(element.zhp === "3")).length)
          updateTotal(response.data.normal.length)
        }
      } catch (err) {
        console.log(err)
      }
    }
    axiosPosts();
  },[])

  return (
    <div className="App">
      <div className="contest-container"> 
        <div className="nav-bar">
            <a href="https://nisamerica.com/nis-classics/vol-2/"><h1 className="nav-link">HOME</h1></a>
            <h1 className="nav-link" onClick={()=>{
              showPreorder(true)
            }}>PREORDER</h1>
            <h1 className="nav-link" onClick={()=>{
              showTrailer(true)
            }}>WATCH TRAILER</h1>
            <a href="https://nisamerica.com/contest/nis-classics/vol-2/reverse-cover/"><h1 className="nav-link">CONTEST</h1></a>
            { preorder && 
                    <div className="pop">
                        <img src="./img/ui/close-btn.png" alt="X" className="close-btn" onClick={
                            () => {
                                showPreorder(false)
                            }
                        }/>
                        <div className="container">
                                <div className="product">
                                    <div className="glamshot">
                                        <img src="./img/glam/LE.jpg" alt="LE Classic" />
                                    </div>
                                    <div className="nav-links">
                                        <a href="https://store.nisamerica.com/prinny-presents-nis-classics-volume-2-makai-kingdom-zhp-limited-edition-nintendo-switch" target="_parent" rel="noreferrer" >
                                            <button className="store-link" onClick={
                                              ()=>{
                                                ReactGA.event({
                                                  category: 'Store',
                                                  action: 'Click',
                                                  label: 'NIS Online'
                                              })
                                              }
                                            }>NIS Online Store</button>
                                        </a>
                                    </div>
                                </div>
                                <div className="product">
                                    <div className="glamshot">
                                        <img src="./img/glam/DE.jpg" alt="LE Classic" />
                                    </div>
                                    <div className="nav-links">
                                    <a href="https://www.bestbuy.com/site/prinny-presents-nis-classics-volume-2-makai-kingdom-reclaimed-and-rebound-zhpunlosing-ranger-vs-darkdeath-evilman-deluxe-edition-nintendo-switch/6483330.p?skuId=6483330" target="_parent" rel="noreferrer" >
                                            <button className="store-link" onClick={
                                              ()=>{
                                                ReactGA.event({
                                                  category: 'Store',
                                                  action: 'Click',
                                                  label: 'BestBuy'
                                              })
                                              }
                                            }>BestBuy</button>
                                        </a>
                                        <a href="https://www.gamestop.com/video-games/nintendo-switch/products/prinny-presents-nis-classics-volume-2---nintendo-switch/11165943.html" target="_blank" rel="noreferrer" onClick = {
                                            ()=>{
                                                ReactGA.event({
                                                    category: 'Link',
                                                    action: 'Click',
                                                    label: 'DE - Gamestop'
                                                })
                                            }
                                        }>
                                            <button className="store-link">Gamestop</button>
                                        </a>

                                        <a href="https://www.amazon.com/Prinny-Presents-NIS-Classics-Reclaimed-Darkdeath/dp/B09GZH3NP2" target="_blank" rel="noreferrer" onClick = {
                                            ()=>{
                                                ReactGA.event({
                                                    category: 'Link',
                                                    action: 'Click',
                                                    label: 'DE - Amazon'
                                                })
                                            }
                                        }>
                                            <button className="store-link">Amazon</button>
                                        </a>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                { trailer && 
                    <div className="pop">
                        <img src="./img/ui/close-btn.png" alt="X" className="close-btn" onClick={
                            () => {
                                showTrailer(false)
                            }
                        }/>
                        <div className="video">
                            <div className="trailer-container" >
                                <iframe src="https://www.youtube.com/embed/bKBBIeFVPS0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ></iframe>
                            </div>
                        </div>
                    </div>
                }
        </div>
        <div className="image-container">
          <img src="./img/logos/NISAClassicV2_Logo.png" alt="Vol 2 Logo" className="prinny"/>
        </div>
        <h2 className="title">Prinny Presents NIS Classics Volume 2:</h2>
        <h2 className="title">Makai Kingdom: Reclaimed and Rebound /</h2>
        <h2 className="title top">ZHP: Unlosing Ranger VS Darkdeath Evilman</h2>
        <div className="title-wrapper">
          <h1 className="contest-title">Reverse Cover Contest</h1>
        </div>
        <div className="text-container">
          <p>A one-two punch of RPG classics are on the way, and YOU can be part of the action, dood! Vote for your favorite alternate cover design and it may be included in the physical release of Prinny Presents NIS Classics Volume 2 for Nintendo Switch™, coming Spring 2022!</p>
          <p>THIS CONTEST HAS ENDED</p>
        </div>
        <div className="image-container">
          <img src="./img/logos/makai-logo.png" alt="" className="makai" />
        </div>
        <h1 className="game-title">
          1. Select a Makai Kingdom Cover:
        </h1>
        <div className="vote-container">
            <VoteCard 
              data = {dataObj}
              gameName = "makai"
              bg = '/img/covers/1.png'
              optionNumber = '1'
              change = {handleChange}
            />
            <VoteCard 
              data = {dataObj}
              gameName = "makai"
              bg = '/img/covers/2.png'
              optionNumber = '2'
              change = {handleChange}
            />
            <VoteCard 
              data = {dataObj}
              gameName = "makai"
              bg = '/img/covers/3.png'
              optionNumber = '3'
              change = {handleChange}
            />
        </div>
        <div className="image-container">
          <img src="./img/logos/ZHP-logo.png" alt="" className="zhp" />
        </div>
        <h1 className="game-title">
          2. Select a ZHP Cover
        </h1>
        <div className="vote-container">
            <VoteCard 
              data = {dataObj}
              gameName = "zhp"
              bg = '/img/covers/4.png'
              optionNumber = '1'
              change = {handleChange}
            />
            <VoteCard 
              data = {dataObj}
              gameName = "zhp"
              bg = '/img/covers/5.png'
              optionNumber = '2'
              change = {handleChange}
            />
            <VoteCard 
              data = {dataObj}
              gameName = "zhp"
              bg = '/img/covers/6.png'
              optionNumber = '3'
              change = {handleChange}
            />
        </div>
        <div className="links">
        <button className="submit" onClick={() => {            
          openResults()
        }}>
            See the current results
          </button>
        </div>
        <div className="results-container">
          <a href="https://nisamerica.com/nis-classics/vol-2/" target="_blank" rel="noopener noreferrer" onClick={
            ()=>{
              ReactGA.event({
                category: 'Link',
                action: 'Click',
                label: 'Learn More'
            })
            }
          }>
            <h1>Learn more about: Prinny Presents NIS Classics Volume 2: Makai Kingdom: Reclaimed and Rebound / ZHP: Unlosing Ranger VS Darkdeath Evilman</h1>
          </a>
        </div> 
        <AnimatePresence
          initial={false}
          exitBeforeEnter={true}
          onExitComplete={()=>null}
        >
        { 
          viewThanks && <Modal handleClose={closeThanks}>
                          <Thanks close = {closeThanks} open ={openResults}/>
                        </Modal> 
        }
        </AnimatePresence>
        <AnimatePresence
          initial={false}
          exitBeforeEnter={true}
          onExitComplete={()=>null}
        >
        { 
          results && <Modal handleClose={closeResults}>
                        <Results
                          makaiOne={makaiOne}
                          makaiTwo={makaiTwo}
                          makaiThree={makaiThree}
                          zhpOne={zhpOne}
                          zhpTwo={zhpTwo}
                          zhpThree={zhpThree}
                          voteTotal={voteTotal}
                        />
                      </Modal> 
        }
        </AnimatePresence>
      </div>
    </div>
  );
}

export default App;
